import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const CustomerOverview = lazy(() => import('../../container/customerInfoManagement/CustomerOverview'));

function CustomerInfoManagement() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={CustomerOverview} />
      <Route path={`${path}/detalles`} component={CustomerOverview} />
    </Switch>
  );
}

export default CustomerInfoManagement;
